var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaild(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 0C13.5625 0 0 13.5625 0 30.625C0 47.6875 13.5625 61.25 30.625 61.25C47.6875 61.25 61.25 47.6875 61.25 30.625C61.25 13.5625 47.6875 0 30.625 0ZM42.4375 45.9375L30.625 34.125L18.8125 45.9375L15.3125 42.4375L27.125 30.625L15.3125 18.8125L18.8125 15.3125L30.625 27.125L42.4375 15.3125L45.9375 18.8125L34.125 30.625L45.9375 42.4375L42.4375 45.9375Z",
    fill: "#FD4811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaild);
export default __webpack_public_path__ + "static/media/faild.8c4960892101fc1b2b37dbbd15b1c548.svg";
export { ForwardRef as ReactComponent };